/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Bodyfat_MissingInputs */

const en_us2_profile_bodyfat_missing = /** @type {(inputs: Profile_Bodyfat_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up-to-date body fat %`)
};

const pt_br2_profile_bodyfat_missing = /** @type {(inputs: Profile_Bodyfat_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de gordura atualizado`)
};

const es_419_profile_bodyfat_missing = /** @type {(inputs: Profile_Bodyfat_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de grasa actualizado`)
};

const pt_pt2_profile_bodyfat_missing = /** @type {(inputs: Profile_Bodyfat_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de gordura atualizada`)
};

const fr_fr2_profile_bodyfat_missing = /** @type {(inputs: Profile_Bodyfat_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de masse grasse à jour`)
};

const de_de2_profile_bodyfat_missing = /** @type {(inputs: Profile_Bodyfat_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Körperfettanteil`)
};

const it_it2_profile_bodyfat_missing = /** @type {(inputs: Profile_Bodyfat_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% di grasso aggiornata`)
};

/**
* | output |
* | --- |
* | "Up-to-date body fat %" |
*
* @param {Profile_Bodyfat_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_bodyfat_missing = /** @type {((inputs?: Profile_Bodyfat_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Bodyfat_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_bodyfat_missing(inputs)
	if (locale === "es-419") return es_419_profile_bodyfat_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_bodyfat_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_bodyfat_missing(inputs)
	if (locale === "de-DE") return de_de2_profile_bodyfat_missing(inputs)
	if (locale === "it-IT") return it_it2_profile_bodyfat_missing(inputs)
	return en_us2_profile_bodyfat_missing(inputs)
});
export { profile_bodyfat_missing as "profile.bodyfat_missing" }